enum EpiTestIds {
	registerButton = 'epi-register-button',
	updateButton = 'epi-update-button',
	cancelButton = 'epi-cancel-button',
	tAndCsModal = 'epi-terms-conditions-modal',
	passwordField = 'epi-password-field',
	fpsField = 'epi-fps-field',
	tAndCs = 'epi-terms-conditions-field',
	confirmationHeading = 'epi-confirmation-heading',
}

export default EpiTestIds;
